import React from 'react'
import { connect } from 'react-redux'
import injectSheet from 'react-jss'
import style from './style'
import exportStyle from './exportStyle'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { updateUiAction } from 'actions/uiActions'
import CameraDetails from 'components/CameraDetails'
import LabelDetails from 'components/LabelDetails'
import FloorPlanDetails from 'components/FloorPlan/FloorPlanDetails'
import MarkupDetails from 'components/MarkupDetails'
import NetworkClosetDetails from 'components/NetworkClosetDetails'
import WireDetails from 'components/WireDetails'
import WiredDeviceDetails from 'components/WiredDeviceDetails'
import DoorControllerDetails from 'components/DoorControllerDetails'
import DoorDetails from 'components/DoorDetails'
import FloorPlanScaler from 'components/FloorPlan/FloorPlanScaler'
import WallInstructions from 'components/WallInstructions'
import ProjectItemList from 'components/ProjectItemList'
import FovPreview from 'components/FovPreview'
import PpfPreview from 'components/PpfPreview'
import getCurrentCamera from 'helpers/cameras/getCurrentCamera'
import MeasurementDetailsPanel from 'components/MeasurementDetailsPanel'
import NetworkClosetExportDetails from 'components/NetworkClosetDetails/exportDetails'
import WiredDeviceExportDetails from 'components/WiredDeviceDetails/exportDetails'
import DoorControllerExportDetails from 'components/DoorControllerDetails/exportDetails'
import DoorExportDetails from 'components/DoorDetails/exportDetails'

const mapStateToProps = ({ ui: { sidebarView, showSideBar, scaling, drawingWall, measurementTool }, messages: { generalError }, currentEntity, cameras, entities: { networkClosets: { byId } } }) => {
  const currentCamera = getCurrentCamera(cameras)
  const currentNetworkCloset = currentEntity.type === 'networkCloset' && byId[currentEntity.id]

  return {
    sidebarView,
    showSideBar,
    scaling,
    drawingWall,
    measurementTool,
    generalError,
    currentEntity,
    currentCamera,
    networkClosetKey: currentNetworkCloset && ('id' + currentNetworkCloset.id + 'start' + currentNetworkCloset.listStartIdx + 'end' + currentNetworkCloset.listEndIdx)
  }
}

class SideBar extends React.Component {
  renderSideBarView() {
    const { sidebarView, currentEntity, currentCamera, scaling, drawingWall, measurementTool } = this.props

    if (scaling) return <FloorPlanScaler />

    if (drawingWall) return <WallInstructions />

    if (measurementTool) return <MeasurementDetailsPanel />

    if (sidebarView === 'cameraList' || !currentEntity) {
      return <ProjectItemList />
    }

    switch(currentEntity.type) {
      case 'camera':
        return currentCamera && currentEntity.id === currentCamera.id ? <CameraDetails /> : <ProjectItemList />
      case 'label':
        return <LabelDetails />
      case 'floorPlan':
        return <FloorPlanDetails />
      case 'networkCloset':
        return <NetworkClosetDetails key={currentEntity.id} />
      case 'wire':
        return <WireDetails key={currentEntity.id} />
      case 'wiredDevice':
        return <WiredDeviceDetails key={currentEntity.id} />
      case 'doorController':
        return <DoorControllerDetails key={currentEntity.id} />
      case 'door':
        return <DoorDetails key={currentEntity.id} />
      case 'circle':
      case 'polygon':
      case 'polyline':
      case 'rectangle':
      case 'wall':
        return <MarkupDetails />
      default:
        return <ProjectItemList />
    }
  }

  render() {
    const { showSideBar, generalError, updateUiAction, classes } = this.props

    return (
      <div ref='SideBar' className={classes.SideBar}>
        <div className={generalError ? classes.errorMessageShow : classes.errorMessageHide}>{generalError}</div>
          {this.renderSideBarView()}
        <div 
          onClick={ updateUiAction.bind(null, { showSideBar: !showSideBar }) }
          className={classes.toggleButtonContainer}>
          <div className={classes.toggleButtonWrapper}>
            <p> { showSideBar ?
              <FontAwesomeIcon icon='caret-right' className={classes.toggleButton} /> :
              <FontAwesomeIcon icon='caret-left' className={classes.toggleButton} /> }
            </p>
          </div>
        </div>
      </div>
    )
  }
}

const ExportSideBar = ({ sidebarView, currentEntity: { type }, networkClosetKey, classes }) =>
  <div
    className={(type === 'networkCloset' || type === 'wiredDevice' || type === 'doorController' || type === 'door') ? classes.DeviceSideBar : classes.ExportSideBar}
    style={{ minWidth: ['doorController', 'door'].includes(type) ? 1000 : 435 }}
  >
    { type === 'camera' &&
      <div>
        <FovPreview />
        <PpfPreview />
      </div>
    }
    { type === 'networkCloset' &&
      <NetworkClosetExportDetails key={networkClosetKey} />
    }
    { type === 'wiredDevice' &&
      <WiredDeviceExportDetails />
    }
    { type === 'doorController' &&
      <DoorControllerExportDetails />
    }
    { type === 'door' &&
      <DoorExportDetails />
    }
  </div>

export default connect(mapStateToProps, { updateUiAction })(EXPORT ? injectSheet(exportStyle)(ExportSideBar) : injectSheet(style)(SideBar))



// WEBPACK FOOTER //
// ./src/components/SideBar/index.js